import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { initMetaPixel } from './utils/metaPixel';
// Initialize Meta Pixel immediately, before React renders
initMetaPixel();
render(<App data-id="element-116" />, document.getElementById('root'));